export default __webpack_public_path__ + "static/media/hide.0d11fbb2.svg";